import theme from 'config/theme';

const USER_HISTORY_CHANGES_DEFAULT_PAGE_SIZE = 500;

const USER_STATUSES_ENUM = {
  1: 'Active',
  2: 'For Deletion',
  3: 'Deleted',
};

const USER_STATUS_COLOR_MAP = {
  1: {
    color: theme.palette.mints.mint900,
    backgroundColor: theme.palette.mints.mint200,
  },
  2: {
    color: theme.palette.oranges.orange900,
    backgroundColor: theme.palette.oranges.orange200,
  },
  3: {
    color: theme.palette.reds.codingRed900,
    backgroundColor: theme.palette.reds.codingRed200,
  },
  default: {
    color: theme.palette.grays.gray900,
    backgroundColor: theme.palette.grays.gray200,
  },
};

export {
  USER_HISTORY_CHANGES_DEFAULT_PAGE_SIZE,
  USER_STATUSES_ENUM,
  USER_STATUS_COLOR_MAP,
};
